import React, { useEffect } from "react";
import { Label } from "reactstrap";

export default function PreviewListComponent({
  handleFileClick,
  handleDelete,
  files,
  readOnly,
}) {
  const getFileIcon = (mimeType) => {
    const mimeTypeMap = {
      "image/": "fa fa-file-image-o",
      "application/pdf": "fa fa-file-pdf-o",
    };

    for (const [key, value] of Object.entries(mimeTypeMap)) {
      if (mimeType.startsWith(key)) {
        return value;
      }
    }

    return "fa fa-file-word-o";
  };

  const truncateFileName = (name) => {
    if (name.length > 30) {
      return name.substring(0, 30) + "...";
    }
    return name;
  };

  return (
    <>
      <Label className="p-3">
        <div className="w-100">Archivos añadidos</div>
      </Label>

      {files.map((file, index) => {
        if (file.deleted) {
          return null;
        }

        return (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "10px",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                flex: 2,
                alignItems: "flex-start",
              }}
            >
              <i
                className={`${getFileIcon(file.mime_type)} text-primary fs-4`}
                style={{ marginRight: "10px" }}
              ></i>
              <label style={{ flex: 1 }}>{truncateFileName(file?.name)}</label>
            </div>
            <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
              <label
                className="uploaded-file"
                onClick={() => handleFileClick(file)}
                style={{
                  cursor: "pointer",
                  marginLeft: "10px",
                  color: "#FFAB4B",
                }}
              >
                Vista previa
              </label>
            </div>
            {!readOnly && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  flex: 1,
                  alignItems: "flex-end",
                }}
              >
                <label
                  className="uploaded-file"
                  onClick={() => handleDelete(index)}
                  style={{ cursor: "pointer", marginLeft: "10px" }}
                >
                  <i className="icon-close text-danger"></i>
                </label>
              </div>
            )}
          </div>
        );
      })}
    </>
  );
}
